import React from "react";
import { render } from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./components/layout/SidebarLeft.css";
import "./i18n"; // <--- Add this
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { HelmetProvider } from "react-helmet-async"; // 1. Import the Provider
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import toast from "react-hot-toast";
// import { IoRefreshCircle } from "react-icons/io5";
import ErrorBoundary from "./components/ErrorBoundary";
import "./firebase";
defineCustomElements(window);

render(
  <Provider store={store}>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </Provider>,
  document.getElementById("root"),
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    // Reload the page after 1 second
    setTimeout(() => {
      window.location.reload();
    }, 1000);

    // Show a toast that lets the user reload the page
    // toast(
    //   (t) => (
    //     <div className="flex align-items-c">
    //       <div className="flex flex-col">
    //         <span style={{ fontSize: "16px", fontWeight: "bold" }}>
    //           New version available!
    //         </span>
    //         <span style={{ fontSize: "13px" }}>Update now to continue.</span>
    //       </div>
    //       <button
    //         onClick={() => {
    //           toast.dismiss(t.id);
    //           if (registration && registration.waiting) {
    //             registration.waiting.postMessage({ type: "SKIP_WAITING" });
    //           }

    //           // reload the page after 1 second
    //           setTimeout(() => {
    //             window.location.reload();
    //           }, 1000);
    //         }}
    //         style={{
    //           padding: "4px 8px",
    //           marginLeft: "10px",
    //           background: "white",
    //           color: "var(--main-color)",
    //           borderRadius: "4px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Update
    //       </button>
    //     </div>
    //   ),
    //   {
    //     duration: Infinity, // Don't auto-close
    //     position: "top-center",
    //     icon: <IoRefreshCircle size={24} />,
    //     style: {
    //       background: "var(--main-color)",
    //       color: "white",
    //     },
    //   },
    // );
  },
});

// // Add listener for controller change to reload the page
// let refreshing = false;
// navigator.serviceWorker.addEventListener("controllerchange", () => {
//   if (!refreshing) {
//     refreshing = true;
//     window.location.reload();
//   }
// });

// Check for updates when tab becomes visible again
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    navigator.serviceWorker.getRegistration().then((registration) => {
      registration?.update();
    });
  }
});

